import { render, staticRenderFns } from "./BetOptions.vue?vue&type=template&id=185c07e6&"
import script from "./BetOptions.vue?vue&type=script&lang=js&"
export * from "./BetOptions.vue?vue&type=script&lang=js&"
import style0 from "./BetOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BetOptions.vue"
export default component.exports